import Navigo from 'navigo';

export default new Navigo(
    null, // root path
    true, // useHash
    '#' // hash symbol
);
